import { IMenuItem } from '@ready/menu.core';
import { RootState } from '../../store';
import { ILocationEditModelResponse } from '@ready/dashboardv2api.contracts';

export const selectMenuItemCacheState = (state: RootState): IMenuItem => state.cache.menuItemCache;
export const selectLocationCacheState = (state: RootState): ILocationEditModelResponse => state.cache.locationCache;
